class PageSize {
  isMobile() {
    return window.innerWidth < 992;
  }
}

export default new PageSize();
